module.exports = __webpack_public_path__ + "assets/img/kv-2f46bab6.jpg";